import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.19 9.384a5.002 5.002 0 0 1 9.993 0h.841c.578 0 .975.577.774 1.116l-.844 2.26a.83.83 0 0 1-.774.538H3.192a.83.83 0 0 1-.774-.537l-.844-2.262a.826.826 0 0 1 .774-1.115zm1.306 0a3.697 3.697 0 0 1 7.38 0zm-.972 2.61-.487-1.305h10.298l-.487 1.304z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.491 3.9v2h-1v-2zM6.191 3.3c0-.331.313-.6.7-.6h2.2c.387 0 .7.269.7.6s-.313.6-.7.6h-2.2c-.387 0-.7-.269-.7-.6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })